import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      players: {
        mass_retag: {
          header: 'HEADER',
          choose_file: 'CHOOSE_FILE',
          drop_file_here: 'DROP_FILE_HERE',
          submit_button: 'SUBMIT',
        },
      },
    },
  }));
}
